import {
  BiodigestateApplicationEvent1Payload,
  BiosolidsApplicationEvent1Payload,
  CompostApplicationEvent1Payload,
  FERTILIZER_TOTAL_AMOUNT_UNIT,
  FERTILIZER_TYPES,
  FertilizerEventPostPutBody,
  LimeApplicationEvent1Payload,
  MACHINERY,
  NITROGEN_FERTILIZER_TYPE,
  ORGANIC_FERTILIZER_ANIMAL_TYPES,
  ORGANIC_FERTILIZER_APPLICATION_METHOD,
  ORGANIC_FERTILIZER_TYPES,
  OrganicFertilizerApplicationEvent1Payload,
  OtherApplicationEvent1Payload,
  REVENUE_CURRENCY,
  SyntheticFertilizerApplicationEvent1Payload,
} from "model";

export type OrganicFertilizerApplicationEvent = {
  isImported: boolean;
  organicFertilizerType: ORGANIC_FERTILIZER_TYPES;
  animalType: ORGANIC_FERTILIZER_ANIMAL_TYPES[];
  applicationMethod: ORGANIC_FERTILIZER_APPLICATION_METHOD;
};

export type SyntheticFertilizerApplicationEvent = {
  productName: string;
  nPercentage: number;
  typeOfNitrogen: NITROGEN_FERTILIZER_TYPE;
  pPercentage?: number;
  kPercentage?: number;
};

export type LimeApplicationEvent = {
  phPriorToApplication: number;
};

export type AnyOtherFertilizerEvent = Record<string, never>;

export type FertilizerEventFormData = {
  note?: string;
  machinery?: MACHINERY[];
  totalAmount: number;
  totalAmountUnit: FERTILIZER_TOTAL_AMOUNT_UNIT;
  fuel?: number;
  operationalCost?: number;
  productCost?: number;
  fertilizerApplicationDate: Date;
  fertilizerType: FERTILIZER_TYPES;
  fieldGuids: string[];
  fertilizerProperties:
    | OrganicFertilizerApplicationEvent
    | SyntheticFertilizerApplicationEvent
    | LimeApplicationEvent
    | AnyOtherFertilizerEvent;
};
export const convertFromFormInput = (
  fertilizerEventFormData: FertilizerEventFormData
): FertilizerEventPostPutBody => {
  let fertilizerProperties = {};
  if (fertilizerEventFormData.fertilizerType === FERTILIZER_TYPES.SYNTHETIC) {
    const syntheticFertilizerProperties =
      fertilizerEventFormData.fertilizerProperties as SyntheticFertilizerApplicationEvent;
    fertilizerProperties = {
      kPercentage: syntheticFertilizerProperties.kPercentage
        ? syntheticFertilizerProperties.kPercentage / 100
        : undefined,
      nPercentage: syntheticFertilizerProperties.nPercentage / 100,
      pPercentage: syntheticFertilizerProperties.pPercentage
        ? syntheticFertilizerProperties.pPercentage / 100
        : undefined,
      productName: syntheticFertilizerProperties.productName,
      typeOfNitrogen: syntheticFertilizerProperties.typeOfNitrogen,
    };
  } else if (
    fertilizerEventFormData.fertilizerType === FERTILIZER_TYPES.ORGANIC
  ) {
    const organicFertilizerProperties =
      fertilizerEventFormData.fertilizerProperties as OrganicFertilizerApplicationEvent;
    fertilizerProperties = {
      animalType: organicFertilizerProperties.animalType,
      applicationMethod: organicFertilizerProperties.applicationMethod,
      isImported: organicFertilizerProperties.isImported,
      organicFertilizerType: organicFertilizerProperties.organicFertilizerType,
    };
  } else if (fertilizerEventFormData.fertilizerType === FERTILIZER_TYPES.LIME) {
    const limeFertilizerProperties =
      fertilizerEventFormData.fertilizerProperties as LimeApplicationEvent;
    fertilizerProperties = {
      phPriorToApplication: limeFertilizerProperties.phPriorToApplication,
    };
  }
  const operationalCost =
    (fertilizerEventFormData.operationalCost as unknown as string) === ""
      ? undefined
      : fertilizerEventFormData.operationalCost;
  const productCost =
    (fertilizerEventFormData.productCost as unknown as string) === ""
      ? undefined
      : fertilizerEventFormData.productCost;
  return {
    note: fertilizerEventFormData.note,
    machinery: fertilizerEventFormData.machinery,
    fuel:
      (fertilizerEventFormData.fuel as unknown as string) === ""
        ? undefined
        : fertilizerEventFormData.fuel,
    operationalCost,
    productCost,
    operationalCostUnit: operationalCost ? REVENUE_CURRENCY.GBP : undefined,
    productCostUnit: productCost ? REVENUE_CURRENCY.GBP : undefined,
    fertilizerProperties: {
      ...fertilizerProperties,
      fertilizerType: fertilizerEventFormData.fertilizerType,
    } as
      | OrganicFertilizerApplicationEvent1Payload
      | SyntheticFertilizerApplicationEvent1Payload
      | LimeApplicationEvent1Payload
      | BiosolidsApplicationEvent1Payload
      | BiodigestateApplicationEvent1Payload
      | CompostApplicationEvent1Payload
      | OtherApplicationEvent1Payload,
    fertilizerApplicationDate: new Date(
      fertilizerEventFormData.fertilizerApplicationDate
    ).toISOString(),
    fieldGuids: fertilizerEventFormData.fieldGuids,
    totalAmount: fertilizerEventFormData.totalAmount,
    totalAmountUnit: fertilizerEventFormData.totalAmountUnit,
  };
};
